import { apiClient } from './client';

export interface RecommendationStats {
  generated: number;
  applied: number;
  dismissed: number;
}

export interface ScorePoint {
  score: number;
  completed_at: string;
}

export interface DashboardSalesInsight {
  revenue: number;
  order_count: number;
  average_order_value: number;
  generated_at: string | null;
}

export interface DashboardProfitInsight {
  net_profit: number;
  profit_margin_percent: number;
  generated_at: string | null;
}

export interface DashboardReviewsSummary {
  pending_count: number;
  approved_count: number;
  average_rating: number;
}

export interface DashboardAiUsage {
  total_cost_usd: number;
  total_calls: number;
  period_days: number;
}

export interface DashboardSummary {
  latest_score: number | null;
  latest_audit_completed_at: string | null;
  score_history: ScorePoint[];
  recommendation_stats: RecommendationStats;
  actionable_recommendations: number;
  unread_notifications: number;
  audits_used_this_month: number;
  audits_remaining: number | null;
  schedule_frequency: string | null;
  next_scheduled_audit_at: string | null;
  sales_insight: DashboardSalesInsight | null;
  profit_insight: DashboardProfitInsight | null;
  reviews: DashboardReviewsSummary;
  ai_usage_30d: DashboardAiUsage;
  fraud_flagged_orders_30d: number;
  support_questions_30d: number;
}

export async function getDashboardSummary(): Promise<DashboardSummary> {
  const res = await apiClient.get<{ data: DashboardSummary }>('/dashboard');
  return res.data.data;
}
